module.exports = __webpack_public_path__ + "img/logo-dex-breadcrumb.74208e9c.svg";